import { useMemo } from "react";
import { ADMIN_ROLE_NAME } from "src/constants";
import { useGetUserDetails } from "src/helpers/UserDetails";

/**
 * Hook to check if the current user has admin role
 * @returns boolean indicating if user is an admin
 */
export const useIsAdmin = (): boolean => {
  const userDetails = useGetUserDetails();

  return useMemo(
    () =>
      Boolean(
        userDetails?.roles?.some((role) => role?.name === ADMIN_ROLE_NAME),
      ),
    [userDetails],
  );
};
